import { useQuery } from '@tanstack/react-query';
import { getAdminDashboardStats } from '../../../../services/dashboard/admin';

export const useAdminDashboardStats = () =>
  useQuery({
    queryKey: ['admin-dashboard-stats'],
    queryFn: getAdminDashboardStats,
  });
